import React, { useState } from 'react';
import { SidebarsIconTooltip } from '../Sidebar/sidebarTooltip/SidebarsIconTooltip';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const AccountIcon: React.FC<IconProps> = ({
  active,
  className = '',
  tooltip = '',
}: IconProps): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const circleFill = hover && !active ? '#cdd5e5' : circleColor(active);
  const fillCol = active ? strokeColor(active) : 'none';
  const strokeCol = active ? strokeColor(active) : '#cdd5e5';
  const underscore = active ? (
    <rect
      x="7.9"
      y="23.2"
      width="8.34831"
      height="1.8"
      rx="1.0254"
      fill={strokeColor(active)}
    />
  ) : (
    <></>
  );
  return (
    <div
      className="sidebar__nav-link__icon__wrapper"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <SidebarsIconTooltip isActive={hover} label={tooltip} />
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle
          cx="12"
          cy="12.5"
          r="12"
          fill={circleFill}
          style={active ? {} : { transitionDuration: '0.1s', opacity: '0.2' }}
        />
        <path
          d="M6.29834 17.1602C6.29834 15.245 7.85094 13.6924 9.76616 13.6924H14.234C16.1492 13.6924 17.7018 15.245 17.7018 17.1602C17.7018 17.5949 17.3494 17.9473 16.9147 17.9473H7.08547C6.65075 17.9473 6.29834 17.5949 6.29834 17.1602Z"
          stroke={strokeCol}
          fill={fillCol}
        />
        <circle
          cx="12.0002"
          cy="8.67154"
          r="2.6188"
          stroke={strokeCol}
          fill={fillCol}
        />
        {underscore}
      </svg>
    </div>
  );
};
